import { shape, string } from "prop-types";

export const Step = shape({
  /** Text to show inside the step */
  content: string.isRequired,

  /** The label to show with the step */
  label: string,
});
